module.exports = "<!-- Imagen de carga con mensaje -->\n<div *ngIf=\"message\" [hidden]=\"!isLoading\" class=\"text-xs-center\">\n  <img class=\"load\" src=\"assets/img/load.gif\">\n  <span>{{message}}</span>\n</div>\n<!-- Solo la imagen de carga -->\n<img *ngIf=\"!message\" [hidden]=\"!isLoading\" class=\"load\" src=\"assets/img/load.gif\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = ./src/app/shared/loader/loader.component.html
// module chunks = main